var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { CommonProvider } from '../../providers/common/common';
var PushReactionComponent = /** @class */ (function () {
    function PushReactionComponent(navCtrl, apiProv, comProv) {
        this.navCtrl = navCtrl;
        this.apiProv = apiProv;
        this.comProv = comProv;
        this.reaction_list = [];
    }
    PushReactionComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        this.push_data = changes['push_data'].currentValue;
        var push_id = this.push_data['id'];
        if (this.push_data['for_personal']) {
            push_id = 'personal_' + this.push_data['id'];
        }
        this.push_data['push_id'] = push_id;
        //this.push_data['like_custom_text'] = 'いいね';
        //this.push_data['like_count'] = 500;
        this.setLikeCount();
        console.log('push_data', this.push_data);
        this.reaction_list = this.comProv.getReactionList();
        console.log('reaction_list', this.reaction_list);
        var index = this.reaction_list.findIndex(function (value) {
            return (value['push_id'] == _this.push_data['push_id']);
        }, this);
        if (index >= 0) {
            this.push_data['is_reacted'] = this.reaction_list[index]['is_reacted'];
        }
    };
    PushReactionComponent.prototype.addReaction = function () {
        var _this = this;
        if (!this.comProv.isLogin()) {
            this.comProv.alertLogin(this.navCtrl);
            return;
        }
        if (this.push_data['is_click']) {
            return;
        }
        this.push_data['is_click'] = true;
        this.apiProv.dispLoader();
        this.apiProv.post(this.push_data['_links']['notification_like_increment']['href'])
            .then(function (data) {
            _this.apiProv.removeLoader();
            _this.push_data['is_click'] = false;
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            _this.dispReaction(true);
        }).catch(function (error) {
            _this.apiProv.removeLoader();
            _this.push_data['is_click'] = false;
            _this.apiProv.statusError(error, _this.navCtrl);
        });
    };
    PushReactionComponent.prototype.deleteReaction = function () {
        var _this = this;
        if (!this.comProv.isLogin()) {
            this.comProv.alertLogin(this.navCtrl);
            return;
        }
        if (this.push_data['is_click']) {
            return;
        }
        this.push_data['is_click'] = true;
        this.apiProv.dispLoader();
        this.apiProv.post(this.push_data['_links']['notification_like_decrement']['href'])
            .then(function (data) {
            _this.apiProv.removeLoader();
            _this.push_data['is_click'] = false;
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            _this.dispReaction(false);
        }).catch(function (error) {
            _this.apiProv.removeLoader();
            _this.push_data['is_click'] = false;
            _this.apiProv.statusError(error, _this.navCtrl);
        });
    };
    PushReactionComponent.prototype.dispReaction = function (is_reacted) {
        var _this = this;
        var reaction_data = {};
        reaction_data['push_id'] = this.push_data['push_id'];
        reaction_data['is_reacted'] = is_reacted;
        this.push_data['is_reacted'] = is_reacted;
        // リアクション数
        if (is_reacted) {
            ++this.push_data['like_count'];
        }
        else {
            --this.push_data['like_count'];
            if (this.push_data['like_count'] < 0) {
                this.push_data['like_count'] = 0;
            }
        }
        this.setLikeCount();
        // ユーザアクション保存
        var index = this.reaction_list.findIndex(function (value) {
            return (value['push_id'] == _this.push_data['push_id']);
        }, this);
        if (index >= 0) {
            this.reaction_list[index] = reaction_data;
        }
        else {
            this.reaction_list.push(reaction_data);
        }
        localStorage.setItem('reaction_list', JSON.stringify(this.reaction_list));
    };
    PushReactionComponent.prototype.setLikeCount = function () {
        var tmp_count;
        if (this.push_data['like_count'] > 1000000) {
            tmp_count = Math.floor(this.push_data['like_count'] / 1000000);
            this.push_data['like_count_disp'] = tmp_count + 'M';
        }
        else if (this.push_data['like_count'] > 1000) {
            tmp_count = Math.floor(this.push_data['like_count'] / 1000);
            this.push_data['like_count_disp'] = tmp_count + 'K';
        }
        else {
            this.push_data['like_count_disp'] = this.push_data['like_count'];
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], PushReactionComponent.prototype, "push_data", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], PushReactionComponent.prototype, "page", void 0);
    PushReactionComponent = __decorate([
        Component({
            selector: 'push-reaction',
            templateUrl: 'push-reaction.html'
        }),
        __metadata("design:paramtypes", [NavController,
            ApiProvider,
            CommonProvider])
    ], PushReactionComponent);
    return PushReactionComponent;
}());
export { PushReactionComponent };
//# sourceMappingURL=push-reaction.js.map


// WEBPACK FOOTER //
// ./src/components/push-reaction/push-reaction.ts.pre-build-optimizer.js